<template>
  <div id="home_root">
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="16">
            <div class="header-name"><img src="image/logo.png"/><span style="font-size: 17px">
              凌恩生物多样性与代谢组关联分析交付系统
            </span></div>
          </el-col>
          <el-col :span="8" class="el-header-col-right">
            <span @click="clickHelp" class="clickHelp">教学视频<i class="el-icon-video-camera"></i></span>
            <el-dropdown @command="handleHeaderCommand">
                            <span style="font-size: 15px">{{
                                user.userName ? user.userName : user.userPhone ? user.userPhone :
                                  user.projectsRow && user.projectsRow.projectId ? user.projectsRow.projectId : ''
                              }}<i
                                class="el-icon-arrow-down el-icon--right"></i>
                            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="updateInfo"
                                  v-if="$store.getters['right/hasRight']('user:editInfo')">编辑信息
                </el-dropdown-item>
                <el-dropdown-item command="updatePwd"
                                  v-if="$store.getters['right/hasRight']('user:editPwd')">修改密码
                </el-dropdown-item>
                <!--                <el-dropdown-item command="email"-->
                <!--                                  v-if="$store.getters['right/hasRight']('user:testEmail')">-->
                <!--                  邮件测试-->
                <!--                </el-dropdown-item>-->
                <el-dropdown-item command="quit">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <quit-project v-if="showQuitButton"></quit-project>
          </el-col>
        </el-row>
      </el-header>
      <el-container class="main content-container">
        <router-view/>
      </el-container>
    </el-container>
    <el-dialog :destroy-on-close="true"
               title="修改密码"
               :visible.sync="showUpdatePwdDialog"
               width="30%">
      <el-form :model="pwds" :rules="checkPwdRule" ref="updatePwdForm" label-width="0px">
        <el-form-item prop="userPassword">
          <el-input v-model="pwds.userPassword" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input v-model="pwds.newPassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item prop="twoPassword">
          <el-input v-model="pwds.twoPassword" type="password" placeholder="请确认密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
              <el-button @click="showUpdatePwdDialog = false">取 消</el-button>
              <el-button type="primary" @click="prepareUpadtePwd">确 定</el-button>
            </span>
    </el-dialog>

    <el-dialog :destroy-on-close="true"
               title="编辑信息"
               :visible.sync="showUpdateInfoDialog"
               width="30%">
      <el-form :model="userInfoForUpdate" :rules="userRule"  ref="updateInfoForm" label-width="90px">
        <el-form-item prop="userName" label="用户名" :required="true" >
          <el-input v-model="userInfoForUpdate.userName"  placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="userPhone" label="手机号码" :required="true" >
          <el-input v-model="userInfoForUpdate.userPhone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item prop="mail" label="邮箱账号">
          <el-input v-model="userInfoForUpdate.mail" placeholder="请输入邮箱账号"></el-input>
        </el-form-item>
        <div v-has-role="['manager','analyzer']">
          <el-form-item prop="authorizationCode" label="邮箱授权码">
            <el-input v-model="userInfoForUpdate.authorizationCode" placeholder="请输入邮箱授权码"></el-input>
          </el-form-item>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">
              <el-button @click="showUpdateInfoDialog = false">取 消</el-button>
              <el-button type="primary" @click="prepareUpadteUserInfo">确 定</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  checkPasswordRule,
  checkPhoneRule,
  checkNameRule,
  checkMail,
  checkAuthorizationCode,
  checkMailOrEmpty
} from '@/utils/utils.js'
import {removeDataInLocalStorage} from '@/utils/localStorageUtils'
import QuitProject from "@/components/QuitProject";

const noQuit = {
  "/log": "",
  "/sampleUpload": "",
  "/manager": "",
  "/saler": "",
  "/analyzer": "",
  "/customer": "",
}
export default {
  components: {QuitProject},
  data() {
    var checkDiffWithOldPwdRule = (rule, value, callback) => {
      if (value === this.pwds.userPassword) {
        return callback(new Error('不能与原密码相同'))
      }
      if (this.pwds.twoPassword && value !== this.pwds.twoPassword) {
        return callback(new Error('密码输入不一致'))
      }
      return callback()
    }
    var checkSameWithNewPwdRule = (rule, value, callback) => {
      if (this.pwds.newPassword && value !== this.pwds.newPassword) {
        return callback(new Error('密码输入不一致'))
      }
      return callback()
    }
    return {
      showUpdateInfoDialog: false,
      userRule: {
        userName: [{
          validator: checkNameRule,
          trigger: 'blur'
        }],
        userPhone: [{
          validator: checkPhoneRule,
          trigger: 'blur'
        }],
        mail: [{
          validator:checkMailOrEmpty,
          trigger: 'blur'
          // required: true,
        }] ,
        authorizationCode: [{
          validator:checkAuthorizationCode,
          trigger: 'blur'
        }]
      },
      menus: [],
      user: {},
      showUpdatePwdDialog: false,
      pwds: {
        userPassword: '',
        newPassword: '',
        twoPassword: ''
      },
      checkPwdRule: {
        userPassword: [{validator: checkPasswordRule, trigger: 'blur'}],
        newPassword: [{validator: checkPasswordRule, trigger: 'blur'}, {
          validator: checkDiffWithOldPwdRule,
          trigger: 'blur'
        }],
        twoPassword: [{validator: checkPasswordRule, trigger: 'blur'}, {
          validator: checkSameWithNewPwdRule,
          trigger: 'blur'
        }]
      },
      userInfoForUpdate: {
        userName: '',
        userPhone: '',
        mail : '',
        authorizationCode : ''
      }
    }
  },
  computed: {
    showQuitButton() {
      var routePath = this.$route.path
      if (noQuit.hasOwnProperty(routePath)) {
        return false
      } else {
        return true
      }
    }
  },

  created() {
    this.getUserInfo()
  },

  methods: {
    prepareUpadtePwd() {
      var that = this
      this.$refs['updatePwdForm'].validate((valid) => {
        if (valid) {
          that.showUpdatePwdDialog = false;
          that.updatePwd('updatePwdForm')
        }
      })
    },
    async updatePwd(formName) {
      const res = await this.$http.put('user/my/pw', {
        'oldPwd': this.pwds.userPassword,
        'newPwd': this.pwds.twoPassword
      })
      if (res.code === 200) {
        this.$messageUi.success('修改成功')
      } else {
        this.$messageUi.error(res.message)
      }
    },
    async getUserInfo(reflush) {
      var userInLS = this.$store.getters['right/getUser']
      if (!userInLS || reflush) {
        const res = await this.$http.get('user/my/info')
        if (res.code == 200) {
          userInLS = res.data
          this.$store.commit('right/setUser', userInLS)
        }
      }
      this.user = userInLS
    },
    deleteIdentityInfo() {
      removeDataInLocalStorage('token')
      removeDataInLocalStorage('role')
      removeDataInLocalStorage('user')
      this.$store.commit('right/initRightInfo')
    },
    handleHeaderCommand: function (event) {
      if (event == 'quit') {
        this.deleteIdentityInfo()
        this.$router.push('/login')
      }
      if (event === 'updatePwd') {
        this.pwds.twoPassword = ''
        this.pwds.userPassword = ''
        this.pwds.newPassword = ''
        this.showUpdatePwdDialog = true
      }
      if (event === 'updateInfo') {
        this.userInfoForUpdate.userName = this.user.userName
        this.userInfoForUpdate.userPhone = this.user.userPhone
        this.userInfoForUpdate.mail = this.user.email
        this.userInfoForUpdate.authorizationCode = this.user.authorCode
        this.showUpdateInfoDialog = true
      }
      if (event === 'email') {
        this.$http.get("/mail/test").then(res => {
          if (res.code === 5934) {
            this.$messageUi({
              message: res.message
            })
          } else if(res.code===200){
            this.$messageUi.success({
              message: '邮件发送成功'
            })
          }
        }).catch(err => {
          this.$messageUi({
            message: err.message
          })
        })
      }
    },
    prepareUpadteUserInfo() {
      var that = this
      this.$refs['updateInfoForm'].validate((valid) => {
        if (valid) {
          that.updateMyInfo()
        }
      })
    },
    async updateMyInfo() {
      if(this.$store.getters['right/getRole'] === 'analyzer'){
        if(!this.userInfoForUpdate.mail){
          this.$messageUi.error("请输入邮箱账号")
          return
        }
        if(!this.userInfoForUpdate.authorizationCode){
          this.$messageUi.error("请输入邮箱授权码")
          return
        }
      }
      if (this.userInfoForUpdate.userName === this.user.userName && this.userInfoForUpdate.userPhone === this.user.userPhone&& this.userInfoForUpdate.mail === this.user.email&& this.userInfoForUpdate.authorizationCode === this.user.authorCode){
        this.$messageUi.info("暂无数据修改")
        this.showUpdateInfoDialog = false;
        return;
      }
      this.showUpdateInfoDialog = false;
      const res = await this.$http.put("user/my", this.userInfoForUpdate)
      if (res.code === 200) {
        this.getUserInfo(true)
        this.$messageUi.success('修改成功')
      } else {
        this.$messageUi.error(res.message)
      }
    },
    clickHelp() {
      window.open('https://13125180.s21v.faiusr.com/58/ABUIABA6GAAgtIDasgYotOTG2wQ.mp4', '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>

.clickHelp {
  cursor: pointer;
  color: #253773;
  font-size: 15px;
  margin-right: 20px;
}
#home_root {
  height: 100%;
}

#sidebar {
  background-color:  #fdfdfe;
}

#sidebar .el-menu .el-submenu li {
  background-color: #2c3b41 !important;
}

#sidebar .el-menu .el-submenu li:hover {
  background-color:  #fdfdfe !important;
}

.el-header-col-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.el-dropdown {
  color: #fff;
}

.header-name {
  display: flex;
  align-items: center;
  height: 100%;
}

.el-row,
.el-col {
  height: 100%;
}


.header-name img {
  width: 40px;
  margin: 0 20px;
}

.el-header {
  width: 100%;
  height: 60px !important;
  background-color: #fdc646;
  color: #fff;
}


.el-aside {
  width: 230px !important;
  height: 100%;
  background-color:  #fdfdfe;
}


.el-container {
  height: 100%;
}

.nodebook-enter, .nodebook-leave-to {
  transform: scale(0.9);
  opacity: 0;
}

.nodebook-enter-to, .nodebook-leave {
  transform: scale(1);
  opacity: 1;
}

.nodebook-enter-active, .nodebook-leave-active {
  transition: all 0.3s;
}

.content-container {
  height: calc(100% - 60px);
}

//这里改了，原来为hidden
.main {
  overflow: hidden;
}

.m-router-view {
  flex: 1;
}

.m-content-display {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>
